import { BaseEntity, Entity as DecribeEntity } from '@avangard/utils/entity';

import type { Maybe, Location } from '@modules/types/graphql';

export type Entity = Maybe<Location>;

@DecribeEntity('LocationEntity')
class LocationEntity extends BaseEntity {
    id: string;
    name: string;

    constructor(location: Entity) {
        super(location);

        this.id = location?.id ?? '';
        this.name = location?.name ?? '-';
    }

    exists() {
        return this.id !== '';
    }
}

export { LocationEntity };
